export type ChecklistItem = { checked: boolean; text: string };

const LINE = /^\s*(?:[-*]\s+|\d+\.\s+)?(?:\[([ xX])\]\s+)?(.*\S)\s*$/;
const MARKER = /^\s*(?:[-*]\s+|\d+\.\s+|\[[ xX]\]\s+)/;

/** A checklist when every non-empty line is a list item, otherwise null (render as prose). */
export function parseChecklist(text: string): ChecklistItem[] | null {
  const lines = text.split("\n").filter((l) => l.trim() !== "");
  if (lines.length === 0 || !lines.every((l) => MARKER.test(l))) return null;
  return lines.map((l) => {
    const m = LINE.exec(l);
    if (!m) return { checked: false, text: l.trim() };
    return { checked: m[1] === "x" || m[1] === "X", text: m[2] };
  });
}
